module.exports = __webpack_public_path__ + "img/smiley_3.39abf27e.svg";